import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=ec4d4eb8&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=ec4d4eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4d4eb8",
  null
  
)

export default component.exports